// Minimal event emitter. on() returns an unsubscribe function. A throwing
// handler never breaks emit() for the others.

export class Emitter {
  constructor() {
    this._handlers = new Map(); // event -> Set<fn>
  }

  on(event, handler) {
    if (typeof handler !== 'function') return () => {};
    let set = this._handlers.get(event);
    if (!set) this._handlers.set(event, (set = new Set()));
    set.add(handler);
    return () => this.off(event, handler);
  }

  once(event, handler) {
    const wrap = (...args) => { this.off(event, wrap); handler(...args); };
    return this.on(event, wrap);
  }

  off(event, handler) {
    this._handlers.get(event)?.delete(handler);
  }

  emit(event, ...args) {
    const set = this._handlers.get(event);
    if (!set) return;
    for (const fn of [...set]) {
      try { fn(...args); } catch (err) {
        console.error(`[Emitter] handler for "${event}" threw`, err);
      }
    }
  }
}
